export const DEFAULT_NAME = 'Umi Max';
export const RESPONSE_CODES = {
  SUCCESS: 0,
  FAILURE: 1,
  UNAUTHORIZED: 401, 
};

// 标注类型
export enum AnnotationTypes {
  SEGMENTATION = 0,  // 轮廓标注
  BOUNDINGBOX = 1, // 框选标注
  CLASSIFICATION = 2, // 分类标注
  MICROSCOPY = 4, // 数字切片标注
  KEYPOINT = 3, // 点选标注
}

// 标注类型标签
export const AnnotationTypeLabels = {
  [AnnotationTypes.SEGMENTATION]: '轮廓勾画',
  [AnnotationTypes.BOUNDINGBOX]: '矩形框标注',
  [AnnotationTypes.CLASSIFICATION]: '分类标注',
  [AnnotationTypes.MICROSCOPY]: '数字切片',
  [AnnotationTypes.KEYPOINT]: '关键点标注',
};

// 定义标注状态
export enum AnnotationStatus {
  UNANNOTATED = 0, // 未标注
  AIDONE = 5,     // AI标注
  IMPORTDONE = 6, // 导入标注
  SAVED = 9,       // 已保存

  SUBMIT = 10,       // 已标注/已提交/待审核
  SUBMIT2 = 12,       // 第1次审核，第2次提交
  SUBMIT3 = 13,       // 第2次审核，第3次提交
  SUBMIT4 = 14,       // 第3次审核，第4次提交
  SUBMIT5 = 15,       // 第4次审核，第5次提交

  SKIP = 20, // 跳过
  REJECT = 30,   // 不通过
  APPROVE_SKIP = 98, // 已审核，跳过（新增）
  APPROVE = 99,    // 已审核

  ARBITRATE = 80,    // 待仲裁
  PENDING_QUALITY_CHECK  = 100,    // 待抽审
  QUALITY_CHECK_PASSED  = 110,    // 通过抽审
  QUALITY_CHECK_REJECT  = 109,    // 抽审不通过
}

// 标注状态标签
export const TaskAnnotationStatusLabels: Record<AnnotationStatus, string> = {
  [AnnotationStatus.UNANNOTATED]: '未标注',
  [AnnotationStatus.SAVED]: '已保存',
  [AnnotationStatus.AIDONE]: 'AI标注',
  [AnnotationStatus.IMPORTDONE]: '导入标注',
  [AnnotationStatus.SKIP]: '已跳过',
  [AnnotationStatus.SUBMIT]: '待审核',
  [AnnotationStatus.SUBMIT2]: '待二审',
  [AnnotationStatus.SUBMIT3]: '待三审',
  [AnnotationStatus.SUBMIT4]: '待四审',
  [AnnotationStatus.SUBMIT5]: '待五审',
  [AnnotationStatus.REJECT]: '不通过',
  [AnnotationStatus.APPROVE_SKIP]: '已审核（跳过）', 
  [AnnotationStatus.APPROVE]: '已审核',
  [AnnotationStatus.ARBITRATE]: '待仲裁',
  [AnnotationStatus.PENDING_QUALITY_CHECK]: '待抽审',
  [AnnotationStatus.QUALITY_CHECK_PASSED]: '抽审通过',
  [AnnotationStatus.QUALITY_CHECK_REJECT]: '抽审不通过',
};
export const DatasetAnnotationStatusLabels = {
  [AnnotationStatus.UNANNOTATED]: '未标注',
  [AnnotationStatus.SAVED]: '已保存',
  [AnnotationStatus.AIDONE]: 'AI标注',
  [AnnotationStatus.IMPORTDONE]: '导入标注',
  [AnnotationStatus.APPROVE_SKIP]: '已跳过',
  [AnnotationStatus.APPROVE]: '已标注',
};

export const AnnotationStatusColors: Record<AnnotationStatus, string> = {
  [AnnotationStatus.UNANNOTATED]: '#a7a7a7', // 未标注 灰色（保持不变）
  [AnnotationStatus.SAVED]: '#186597',       // 已保存 蓝色
  [AnnotationStatus.SUBMIT]: '#F67241',        // 待审核 绿色
  [AnnotationStatus.SUBMIT2]: '#EC9A30',        // 待二审 绿色
  [AnnotationStatus.SUBMIT3]: '#BA5A14',        // 待三审 绿色
  [AnnotationStatus.SUBMIT4]: '#98265E',        // 待四审 绿色
  [AnnotationStatus.SUBMIT5]: '#0FA002',        // 待五审 绿色
  [AnnotationStatus.REJECT]: '#FA541C',    // 不通过 红色
  [AnnotationStatus.AIDONE]: '#6B1FC9',      // AI标注 紫色
  [AnnotationStatus.IMPORTDONE]: '#F67241',  // 导入标注 橙色
  [AnnotationStatus.APPROVE]: '#33B5E5',     // 已审核 青色
  [AnnotationStatus.SKIP]: '#804011',        // 已跳过 黄色
  [AnnotationStatus.APPROVE_SKIP]: '#6B1FC9',  // 已审核，跳过 绿色
  [AnnotationStatus.ARBITRATE]: '#1ABC9C',        // 待仲裁 绿色
  [AnnotationStatus.PENDING_QUALITY_CHECK]: '#4078F2',        // 待抽审 绿色
  [AnnotationStatus.QUALITY_CHECK_PASSED]: '#52C41A',  // 通过抽审 青色
  [AnnotationStatus.QUALITY_CHECK_REJECT]: '#FA541C',    // 抽审不通过 红色
};
 
const submitVal=AnnotationStatus.SUBMIT+','+AnnotationStatus.SUBMIT2+','+AnnotationStatus.SUBMIT3+','+AnnotationStatus.SUBMIT4+','+AnnotationStatus.SUBMIT5;
const submitAndSkipVal=submitVal+','+AnnotationStatus.SKIP;
// 标注状态下拉选项（按指定顺序）
export const TaskAnnotationStatusOptions = [
  { value: AnnotationStatus.UNANNOTATED, label: TaskAnnotationStatusLabels[AnnotationStatus.UNANNOTATED] }, // 未标注
  // { value: submitVal, label: TaskAnnotationStatusLabels[AnnotationStatus.SUBMIT] },               // 待审核,不含跳过
  { value: AnnotationStatus.SKIP, label: TaskAnnotationStatusLabels[AnnotationStatus.SKIP] },               // 已跳过
  { value: AnnotationStatus.SAVED, label: TaskAnnotationStatusLabels[AnnotationStatus.SAVED] },             // 已保存
  { value: AnnotationStatus.IMPORTDONE, label: TaskAnnotationStatusLabels[AnnotationStatus.IMPORTDONE] },   // 导入标注
  { value: AnnotationStatus.AIDONE, label: TaskAnnotationStatusLabels[AnnotationStatus.AIDONE] },           // AI标注  
  { value: AnnotationStatus.REJECT, label: TaskAnnotationStatusLabels[AnnotationStatus.REJECT] },       // 不通过
  { value: AnnotationStatus.SUBMIT, label: TaskAnnotationStatusLabels[AnnotationStatus.SUBMIT] },               // 待审核,不含跳过
  { value: AnnotationStatus.SUBMIT2, label: TaskAnnotationStatusLabels[AnnotationStatus.SUBMIT2] },               // 待审核,不含跳过
  { value: AnnotationStatus.SUBMIT3, label: TaskAnnotationStatusLabels[AnnotationStatus.SUBMIT3] },               // 待审核,不含跳过
  { value: AnnotationStatus.SUBMIT4, label: TaskAnnotationStatusLabels[AnnotationStatus.SUBMIT4] },               // 待审核,不含跳过
  { value: AnnotationStatus.APPROVE, label: TaskAnnotationStatusLabels[AnnotationStatus.APPROVE] },        // 已审核
  { value: AnnotationStatus.APPROVE_SKIP, label: TaskAnnotationStatusLabels[AnnotationStatus.APPROVE_SKIP] }, // 已审核，跳过（新增）     
  { value: AnnotationStatus.ARBITRATE, label: TaskAnnotationStatusLabels[AnnotationStatus.ARBITRATE] },       // 待仲裁
  { value: AnnotationStatus.PENDING_QUALITY_CHECK, label: TaskAnnotationStatusLabels[AnnotationStatus.PENDING_QUALITY_CHECK] },       // 待抽审
  { value: AnnotationStatus.QUALITY_CHECK_PASSED, label: TaskAnnotationStatusLabels[AnnotationStatus.QUALITY_CHECK_PASSED] },       // 通过抽审
  { value: AnnotationStatus.QUALITY_CHECK_REJECT, label: TaskAnnotationStatusLabels[AnnotationStatus.QUALITY_CHECK_REJECT] },       // 抽审不通过
];

export const TaskAnnotatorStatusOptions = [
  { value: AnnotationStatus.UNANNOTATED+','+AnnotationStatus.SAVED+','+AnnotationStatus.IMPORTDONE+','+AnnotationStatus.AIDONE+','+AnnotationStatus.REJECT, label: "未提交" }, // 未标注
  { value: AnnotationStatus.REJECT, label: TaskAnnotationStatusLabels[AnnotationStatus.REJECT] },       // 不通过
  { value: AnnotationStatus.SUBMIT, label: TaskAnnotationStatusLabels[AnnotationStatus.SUBMIT] },               // 待审核,不含跳过
  { value: AnnotationStatus.SUBMIT2, label: TaskAnnotationStatusLabels[AnnotationStatus.SUBMIT2] },               // 待审核,不含跳过
  { value: AnnotationStatus.SUBMIT3, label: TaskAnnotationStatusLabels[AnnotationStatus.SUBMIT3] },               // 待审核,不含跳过
  { value: AnnotationStatus.SUBMIT4, label: TaskAnnotationStatusLabels[AnnotationStatus.SUBMIT4] },               // 待审核,不含跳过
  { value: AnnotationStatus.APPROVE, label: TaskAnnotationStatusLabels[AnnotationStatus.APPROVE] },        // 已审核
  { value: AnnotationStatus.APPROVE_SKIP, label: TaskAnnotationStatusLabels[AnnotationStatus.APPROVE_SKIP] }, // 已审核，跳过（新增）     
  // { value: submitAndSkipVal, label: "待审核" },     
  // { value: AnnotationStatus.APPROVE+','+AnnotationStatus.APPROVE_SKIP, label: "已审核"}, 
];

export const TaskReviewerStatusOptions = [
  { value: submitAndSkipVal, label: "未审核" },     
  // { value: AnnotationStatus.APPROVE+','+AnnotationStatus.APPROVE_SKIP, label: "已审核"}, 
  { value: AnnotationStatus.SUBMIT, label: TaskAnnotationStatusLabels[AnnotationStatus.SUBMIT] },               // 待审核,不含跳过
  { value: AnnotationStatus.SUBMIT2, label: TaskAnnotationStatusLabels[AnnotationStatus.SUBMIT2] },               // 待审核,不含跳过
  { value: AnnotationStatus.SUBMIT3, label: TaskAnnotationStatusLabels[AnnotationStatus.SUBMIT3] },               // 待审核,不含跳过
  { value: AnnotationStatus.SUBMIT4, label: TaskAnnotationStatusLabels[AnnotationStatus.SUBMIT4] },               // 待审核,不含跳过
  { value: AnnotationStatus.APPROVE, label: TaskAnnotationStatusLabels[AnnotationStatus.APPROVE] },        // 已审核
  { value: AnnotationStatus.APPROVE_SKIP, label: TaskAnnotationStatusLabels[AnnotationStatus.APPROVE_SKIP] }, // 已审核，跳过（新增）     
];

export const DatasetAnnotationStatusOptions = [
  { value: AnnotationStatus.UNANNOTATED, label: DatasetAnnotationStatusLabels[AnnotationStatus.UNANNOTATED] }, // 未标注
  { value: AnnotationStatus.APPROVE, label: DatasetAnnotationStatusLabels[AnnotationStatus.APPROVE] },               // 已提交
  { value: AnnotationStatus.APPROVE_SKIP, label: DatasetAnnotationStatusLabels[AnnotationStatus.APPROVE_SKIP] },               // 已跳过
  { value: AnnotationStatus.SAVED, label: DatasetAnnotationStatusLabels[AnnotationStatus.SAVED] },             // 已保存
  { value: AnnotationStatus.IMPORTDONE, label: DatasetAnnotationStatusLabels[AnnotationStatus.IMPORTDONE] },   // 导入标注
  { value: AnnotationStatus.AIDONE, label: DatasetAnnotationStatusLabels[AnnotationStatus.AIDONE] },           // AI标注
];

// 任务状态枚举
export enum TaskStatus {
  SAVED = 0,      // 未启动
  RUNNING = 10,   // 进行中
  PAUSE = 20,     // 暂停
  DONE = 99,      // 已完成
}

// 任务状态标签
export const TaskStatusLabels: Record<TaskStatus, string> = {
  [TaskStatus.SAVED]: '未启动',
  [TaskStatus.RUNNING]: '进行中',
  [TaskStatus.PAUSE]: '暂停',
  [TaskStatus.DONE]: '已完成',
};

// 状态颜色常量
export const TaskStatusColors: Record<number, string> = {
  [TaskStatus.SAVED]: '#8a8a8a',      // 未启动 灰色
  [TaskStatus.RUNNING]: '#2C50ED',    // 已启动 蓝色
  [TaskStatus.PAUSE]: '#df6920',      // 已暂停 紫色
  [TaskStatus.DONE]: '#00CE12',       // 已完成 绿色
};

// 任务状态下拉选项
export const TaskStatusOptions = [
  { value: TaskStatus.SAVED, label: TaskStatusLabels[TaskStatus.SAVED] },
  { value: TaskStatus.RUNNING, label: TaskStatusLabels[TaskStatus.RUNNING] },
  { value: TaskStatus.PAUSE, label: TaskStatusLabels[TaskStatus.PAUSE] },
  { value: TaskStatus.DONE, label: TaskStatusLabels[TaskStatus.DONE] },
];

// 管理员damin-用户管理-用户来源
export const USER_FROM = {
  ADMIN_CREATE: 0,      // 管理员创建     
  REGISTER: 1,       // 注册
  SYS_ADMIN_CREATE: 8,   // 系统管理员创建
  TENANT_ADMIN_CREATE: 9 // 租户管理员创建
};

export const USER_FROM_LABELS = {
  [USER_FROM.REGISTER]: '注册',
  [USER_FROM.ADMIN_CREATE]: '管理员创建',
  [USER_FROM.SYS_ADMIN_CREATE]: '系统管理员创建',
  [USER_FROM.TENANT_ADMIN_CREATE]: '租户管理员创建',
};
// 租户-加入来源（用户来源）
export const TENANT_JOIN_SOURCE = {
  ADMIN_CREATE: 1,   // 管理员创建
  INVITE_CODE: 2,    // 邀请码加入
};

export const TENANT_JOIN_SOURCE_LABELS: Record<number, string> = {
  [TENANT_JOIN_SOURCE.ADMIN_CREATE]: '管理员创建',
  [TENANT_JOIN_SOURCE.INVITE_CODE]: '邀请码加入',
};

// 数据集中的标签颜色-对应标注平台标签列表的颜色
export const LabelColor = [
  "#dd5454ff",
  "#4de479ff",
  "#a646ebff",
  "#bdb474ff",
  "#6db6c4ff",
  "#cc659dff",
  "#7bd55eff",
  "#5d57daff",
  "#e18050ff",
  "#49e8acff",
  "#b577baff",
  "#b0c170ff",
  "#6999c8ff",
  "#d06178ff",
  "#5ad765ff",
  "#8753deff",
  "#e5b24cff",
  "#7ab7b5ff",
  "#be73abff",
  "#95c56cff",
  "#6476cdff",
  "#d46c5dff",
  "#56db8dff",
  "#b74fe2ff",
  "#e9e948ff",
  "#76a7bbff",
  "#c26f92ff",
  "#74c968ff",
  "#7360d1ff",
  "#d89359ff",
  "#52dfbcff",
  "#e64be0ff",
  "#a3b879ff",
  "#728fbfff",
  "#c66b72ff",
  "#63ce7aff",
  "#995cd5ff",
  "#dcc055ff",
  "#4ed7e3ff",
  "#ea47adff",
  "#8dbc75ff",
  "#6e71c3ff",
  "#ca8067ff",
  "#5fd29dff",
  "#c358d9ff",
  "#cee051ff",
  "#4aa6e7ff",
  "#b9788bff",
  "#71c071ff",
  "#856ac7ff",
  "#cfa262ff",
  "#5bd6c6ff",
  "#dd54c6ff",
  "#9fe44dff",
  "#466febff",
  "#bd7774ff",
  "#6dc48aff",
  "#a565ccff",
  "#d3c95eff",
  "#57bfdaff",
  "#e15099ff",
  "#6ae849ff",
  "#7c77baff",
  "#c18e70ff",
  "#69c8a8ff",
  "#cb61d0ff",
  "#b8d75aff",
  "#5393deff",
  "#e54c65ff",
  "#7ab782ff"
];



// 医学影像模态类型
export enum ModalityTypes {
  CT = 'CT',
  MRI = 'MRI',
  DR = 'DR',
  PET = 'PET',
  DSA = 'DSA',
  US = 'US',
  EGD = 'EGD',
  FUNDUS = 'Fundus',
  DERM = 'Derm',
  PATHOLOGY = 'Pathology',
  OTHER = 'other',
}

// 医学影像模态标签映射
export const ModalityLabels = {
  [ModalityTypes.CT]: 'CT',
  [ModalityTypes.MRI]: 'MRI',
  [ModalityTypes.DR]: 'DR',
  [ModalityTypes.PET]: 'PET',
  [ModalityTypes.DSA]: 'DSA',
  [ModalityTypes.US]: '超声',
  [ModalityTypes.EGD]: '内窥镜',
  [ModalityTypes.FUNDUS]: '眼底',
  [ModalityTypes.DERM]: '皮肤镜',
  [ModalityTypes.PATHOLOGY]: '病理',
  [ModalityTypes.OTHER]: '其他',
};

// 生成选项数组的工具函数
export const getModalityOptions = () => {
  return Object.values(ModalityTypes)?.map(value => ({
    value,
    label: ModalityLabels[value]
  }));
};

// AI模型执行状态
// 定义状态枚举
export enum AIModelStatus {
  INIT = 0, // 未启动
  RUNNING = 1, // 进行中
  PAUSE = 2, // 暂停
  DONE = 3, // 已完成
}

// 定义状态对应的描述
export const AIModelStatusMap: Record<AIModelStatus, string> = {
  [AIModelStatus.INIT]: "排队中",
  [AIModelStatus.RUNNING]: "进行中",
  [AIModelStatus.PAUSE]: "暂停",
  [AIModelStatus.DONE]: "已完成",
};
// 定义状态对应的颜色
export const AIModelStatusColors: Record<AIModelStatus, string> = {
  [AIModelStatus.INIT]: "#a7a7a7",      // 未启动 灰色
  [AIModelStatus.RUNNING]: "#2C50ED",   // 进行中 蓝色
  [AIModelStatus.PAUSE]: "#df6920",     // 暂停 橙色
  [AIModelStatus.DONE]: "#00CE12",      // 已完成 绿色
};

// 产品类型映射
export const SKU_TYPE_MAP: Record<number, string> = {
  1: '月',
  2: '季',
  3: '半年',
  4: '年',
  5: '个',
};

// 订单状态枚举
export enum OrderStatus {
  UNPAID = 0, // 待支付
  PAYING = 10, // 支付中
  PAYED = 20, // 已支付
  COMPLETED = 30, // 已完成
  CANCELED = 40, // 已取消
}

// 订单状态对应的描述
export const OrderStatusMap: Record<OrderStatus, string> = {
  [OrderStatus.UNPAID]: "待支付",
  [OrderStatus.PAYING]: "支付中",
  [OrderStatus.PAYED]: "已支付",
  [OrderStatus.COMPLETED]: "已完成",
  [OrderStatus.CANCELED]: "已取消",
};
// 取消订单类型枚举
export enum CancelType {
  PAY_TIMEOUT = 10, // 超时未支付
  AFTER_SALE_CLOSE = 20, // 退款关闭
  MEMBER_CANCEL = 30, // 买家取消
}

// 取消订单类型对应的描述
export const CancelTypeMap: Record<CancelType, string> = {
  [CancelType.PAY_TIMEOUT]: "超时未支付",
  [CancelType.AFTER_SALE_CLOSE]: "退款关闭",
  [CancelType.MEMBER_CANCEL]: "买家取消",
};

//窗宽窗位自定选项
export const WWWL_CONFIG = [
  { value: '', label: '设置窗宽窗位' },
  { value: '1500,-600', label: '肺窗 1500 / -600' },
  { value: '250,30', label: '纵膈窗 250 / 30' },
  { value: '1000,250', label: '骨 1000 / 250' },
  { value: '400,40', label: '软组织 400 / 40' },
  { value: '80,30', label: '脑组织 80 / 30' },
  { value: '200,40', label: '垂体 200 / 40' },
  { value: '80,30', label: '脑出血 80 / 30' },
  { value: '60,30', label: '脑梗塞 60 / 30' },
  { value: '150,30', label: '颌面部 150 / 30' },
  { value: '300,30', label: '咽喉 300 / 30' },
  { value: '400,40', label: '腹部 400 / 40' },
  { value: '200,25', label: '肾脏 200 / 25' },
  { value: '350,50', label: '胰腺 350 / 50' },
];


// localStorage key constants
export const PROJECT_PREFIX = 'darts';

export const DATASET_FILTER_KEY = `${PROJECT_PREFIX}-dataset-filterData`;
export const TASK_FILTER_KEY = `${PROJECT_PREFIX}-task-filterData`;
export const USER_KEY = `${PROJECT_PREFIX}-user`;

export const ACCESS_TOKEN_KEY = `${PROJECT_PREFIX}-accessToken`;
export const EXPIRES_TIME_KEY = `${PROJECT_PREFIX}-expiresTime`;
export const REFRESH_TOKEN_KEY = `${PROJECT_PREFIX}-refreshToken`;

// 上传日志状态
export enum UploadStatus {
  UNDO = 0,      // 已上传，未执行
  SUCCESS = 1,   // 执行成功
  ERROR = -1,    // 执行失败
}

//标注单位自定选项
export const  ANN_UNIT = [
  { value: 'series', label: '序列' },
  { value: 'study', label: '检查' },
  { value: 'patient', label: '患者' },
];




// 色卡默认颜色
export interface ColorCard {
  key: number;
  name: string;
  color: string;
}

// 默认色卡数据（5个）
export const DEFAULT_COLOR_CARDS: ColorCard[] = [
  {
    key: 0,
    name: '淡红',
    color: '#F8898D', // 正常舌色
  },
  {
    key: 1,
    name: '红',
    color: '#FF1900', // 主热证
  },
  {
    key: 2,
    name: '暗红',
    color: '#AD190A', // 主热入营血
  },
  {
    key: 3,
    name: '淡紫',
    color: '#a317df', // 主气血两虚
  },
  {
    key: 4,
    name: '青紫',
    color: '#6B2D5C', // 主血瘀证
  },
  {
    key: 5,
    name: '淡红',
    color: '#E8C8B8',
  },
  {
    key: 6,
    name: '红绛',
    color: '#C41A2A',
  },
  {
    key: 7,
    name: '紫暗',
    color: '#4A2C4A',
  },
  {
    key: 8,
    name: '淡紫',
    color: '#9B6B8C',
  },
  {
    key: 9,
    name: '苍白',
    color: '#E8D8D0',
  },
];

